
import { Link } from "react-router-dom";

function Careers() {
  return (
   <main id="main">

  <div className="page-header">
    <svg viewBox="0 0 100 100" className="page-header__seal" aria-hidden="true" style={{color:'#fff'}}>
      <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="0.8"/>
      <path id="sealTopB" d="M 14,50 A 36,36 0 1,1 86,50" fill="none"/>
      <text fontSize="5.4" letterSpacing="1.5" fill="currentColor"><textPath href="#sealTopB" startOffset="50%" textAnchor="middle">JUSTICE FOR ALL</textPath></text>
    </svg>
    <div className="container">
      <div className="breadcrumb"><Link to='/'>Home</Link> / Careers</div>
      <h1>Careers</h1>
      <p>Join the Legal Aid & Justice Authority and contribute to a fair, inclusive and accessible justice system.</p>
    </div>
  </div>

  

  <section className="section section--alt">
    <div className="container">
      <div className="section__head">
        <div><span className="eyebrow">Record</span><h2>Latest Jobs in LAJA</h2></div>
      </div>
      <table className="past-events-table">
        <thead>
          <tr><th>Start Date</th><th>End Date</th><th>Title</th><th>Download</th><th>Status</th></tr>
        </thead>
        <tbody>
          <tr><td>8 Feb 2026</td><td>23 Feb 2026</td><td>SITUATION VACANT</td><td><Link to="/images/laja_jobs.pdf" target="_blank" rel="noopener noreferrer" className="btn btn--outline-navy btn--sm">View Advertisement</Link></td><td><span style={{color:'red'}}>Closed</span></td></tr>
          
        </tbody>
      </table>
    </div>
  </section>

</main>
  );
}

export default Careers;
